import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import defectReducer from "./slices/defectSlice";
import inspectionReducer from "./slices/inspectionSlice";
import positiveItemReducer from "./slices/positiveItemSlice";
import userReducer from "./slices/userSlice";
import aiSummaryReducer from "./slices/aiSummarySlice";

export const store = configureStore({
    reducer: {
        defect: defectReducer,
        inspection: inspectionReducer,
        positiveItem: positiveItemReducer,
        user: userReducer,
        aiSummary: aiSummaryReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
